export enum EnumOrderEmailState {
  ProjectConfirmation = 1,
  PrintOrderSummary = 2,
  PoPrinting = 3,
  PrintProjectApproval = 4,
}
